import React, { useEffect, useState } from 'react';
import apiService from '../../services/apiService';
import CreateProjectWizard from '../CreateProjectWizard';
import { useToast } from '../ToastProvider';
import { useI18n } from '../../utils/i18n';

// #602: „Zum Vorgang“ öffnet den Vorgang des Tickets im Bearbeiten-Dialog der
// Vorgangs-Ansicht (CreateProjectWizard), über dem Ticket statt per Seitenwechsel.
// Geladen wird über die Einzelrouten, damit auch automatisch angelegte Vorgänge
// (Zeitblock-Duplikate) aufgehen: Die Liste in der Vorgangs-Ansicht zeigt sie nicht.

/**
 * Was der Dialog öffnet, nach der Regel der Vorgangs-Ansicht: Ein Teilvorgang
 * mit Eltern-Vorgang öffnet den Vorgang, ohne ihn sich selbst. Liefert
 * `{ mode, data, darfBearbeiten }`, oder null, wenn das Ticket an keinem hängt.
 */
export async function ladeVorgangFuerTicket(ticket, api = apiService) {
  if (!ticket) return null;
  if (ticket.subprojectId) {
    const sub = await api.getSubproject(ticket.subprojectId);
    if (sub?.subproject?.projectId) {
      const proj = await api.getProject(sub.subproject.projectId);
      return { mode: 'project', data: proj.project, darfBearbeiten: !!proj.darfBearbeiten };
    }
    return { mode: 'subproject', data: sub.subproject, darfBearbeiten: !!sub.darfBearbeiten };
  }
  if (ticket.projectId) {
    const proj = await api.getProject(ticket.projectId);
    return { mode: 'project', data: proj.project, darfBearbeiten: !!proj.darfBearbeiten };
  }
  return null;
}

// Einfügen und Ablegen im Dialog gehören nicht zum Ticket dahinter: Die
// Ereignisse laufen im React-Baum bis zum Overlay des Ticket-Details hoch, und
// dort würde eine eingefügte Datei als Ticket-Anhang hochgeladen.
const anhalten = (e) => e.stopPropagation();

export default function VorgangDialog({ ticket, onClose, onGespeichert }) {
  const [vorgang, setVorgang] = useState(null);
  const { pushToast } = useToast();
  const { t } = useI18n();

  useEffect(() => {
    let abgebrochen = false;
    ladeVorgangFuerTicket(ticket)
      .then((v) => {
        if (abgebrochen) return;
        if (v) setVorgang(v); else onClose();
      })
      .catch((e) => {
        if (abgebrochen) return;
        console.error('Vorgang laden fehlgeschlagen:', e);
        pushToast({ type: 'error', message: t('ticketDetail.projectLoadError', 'Der Vorgang konnte nicht geladen werden.') });
        onClose();
      });
    return () => { abgebrochen = true; };
    // Nur beim Öffnen laden, der Dialog lebt kürzer als das Ticket
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!vorgang) return null;
  return (
    <div onPaste={anhalten} onDragEnter={anhalten} onDragOver={anhalten} onDragLeave={anhalten} onDrop={anhalten}>
      <CreateProjectWizard
        initialMode={vorgang.mode}
        initialData={vorgang.data}
        readOnly={!vorgang.darfBearbeiten}
        onClose={onClose}
        onCreated={async () => {
          try { if (onGespeichert) await onGespeichert(); } finally { onClose(); }
        }}
      />
    </div>
  );
}
